import { render, staticRenderFns } from "./AddCampusStudentsComponent.vue?vue&type=template&id=36e4dbdf&"
import script from "./AddCampusStudentsComponent.vue?vue&type=script&lang=js&"
export * from "./AddCampusStudentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports